module.exports = __webpack_public_path__ + "img/2-2.f96e1327.svg";